let pt = {
  bind: function (el, binding, vnode) {
   

    
  },
  inserted: function (el, binding, vnode) { 
    var s = JSON.stringify
    el.innerHTML = `<p id="marquee"><span id="copy">${s(binding.value)}</span>`
    let marquee = document.getElementById('marquee')
    let copy = document.getElementById('copy')
    let width = copy.getBoundingClientRect().width 
    let outerWidth = el.getBoundingClientRect().width 
    let distance = 0 // 位移距离
    let _intval=null
    el.parentNode.addEventListener("mouseenter",function(){
      if(width<outerWidth) return false
      let _intval=setInterval(function () { 
        distance = distance - 1
         // 如果位移超过文字宽度，则回到起点
        if (-distance >= width-outerWidth) {
          clearInterval(_intval)
        }
        marquee.style.transform = 'translateX(' + distance + 'px)'
      }, 20)
    },false);
    el.parentNode.addEventListener("mouseleave",function(){
      _intval && clearInterval(_intval)
      distance = 0 
      marquee.style.transform = 'translateX(0px)'
    },false);
  },
  update: function (el, binding, vnode) { 
    

    
   
  },
  componentUpdated: function (el, binding, vnode) { 

  },
  unbind: function (el, binding, vnode) { 

  }

}


let minlength = {
  bind: function (el, binding, vnode) { //1-被绑定

    
  },
  inserted: function (el, binding, vnode) { //2-被插入
    var winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    el.style.minHeight = winHeight + 'px'
  },
  update: function (el, binding, vnode) { //3-更新

  },
  componentUpdated: function (el, binding, vnode) { //4-更新完成

  },
  unbind: function (el, binding, vnode) { //5-解绑

  }
}
let computedWidth = {
  bind: function (el, binding, vnode) { //1-被绑定

    // window.screenWidth = document.body.clientWidth;
    // if (window.screenWidth > 600) {

    // } else {
    //   var winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    //   el.style.minHeight = winHeight + 'px'
    // }
    //el.style.minHeight = '400px'


  },
  inserted: function (el, binding, vnode) { //2-被插入
    var _height=0;
    var childrenLength=el.getElementsByTagName('li').length;
    for(var i=0;i<childrenLength;i++){
        _height+=Math.ceil(el.getElementsByTagName('li')[i].offsetWidth+1);
    }
   el.style.width = _height + 'px';
//    setTimeout(function(){
//     binding.value.refresh();
//    },500)
  },
  update: function (el, binding, vnode) { //3-更新

  setTimeout(function(){
    //alert(111)
    binding.value.refresh();
   },0)


  },
  componentUpdated: function (el, binding, vnode) { //4-更新完成

  },
  unbind: function (el, binding, vnode) { //5-解绑

  }
}


export {
  pt,minlength,computedWidth
}




// WEBPACK FOOTER //
// ./src/directive/index.js